import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateGenResponse } from "../../redux/action/genericSurveyAction";
import { updateUserInfo } from "../../redux/action/surveyAction";
import { setCampaign } from "../../redux/action/campaignAction";
import { getSurveyResponse, getSurveyById } from "../../services/survey.service";
import { getCampaigsByRn } from "../../services/campaign.service";
import { SCBM_STATES_CAMPAIGN, CRS_REQUEST_STATUS_OBJ, SCBM_USER_TYPE } from "../../utils/surveyLiterals";
import { ERR_DESC_REQUEST_NUMBER, ERR_TITLE_REQUEST_NUMBER } from "../../utils/errorLiterals";
import { useUserInfo } from "../../providers/userProvider";
import { useOktaAuth } from "@okta/okta-react";
import OSSurveyPage from "./OSSurveyPage";

function validationRules(respCampaign, userInfo) {
  let error;
  if (respCampaign) {
    if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
      //it is normal user, we have to validate that the current user has the supplier
      if (!userInfo.suppliers || userInfo.suppliers.length <= 0 || !userInfo.suppliers.includes(respCampaign.assignments[0].supplierNumber)) {
        error = "No suppliers assigned";
      } //else everything is OK
    } //else Read only for the deere employee
  } else {
    //The assignment does not exist
    error = "No campaing found";
  }
  return error;
}

function isValidRN(rn) {
  return rn && rn.length <= 19 && !isNaN(rn) && Number.isInteger(parseFloat(rn)); //Size in DB
}

function sentToReview(campaignAssigned) {
  return campaignAssigned.assignments[0].status === CRS_REQUEST_STATUS_OBJ.COMPLETE || campaignAssigned.status === SCBM_STATES_CAMPAIGN.CLOSED;
}

const HomeOSPage = ({...props}) => {
  const actualURL = window.location.href;
  const { authState } = useOktaAuth();
  const userInfo = useUserInfo();
  const [survey, setSurvey] = useState(undefined);
  const [containsError, setContainsError] = useState(false);
  const [campaignAssigned, setCampaignAssigned] = useState();
  const dispatch = useDispatch();
  const [surveyResponseHome, setSurveyResponseHome] = useState(undefined);

  let value = Object.fromEntries(new URLSearchParams(props.location.search));
  const rn = value.rn;

  //Remove user info from redux
  if (userInfo) {
    dispatch(updateUserInfo(userInfo));
  }

  useEffect(() => {
    if (userInfo && rn && !campaignAssigned && isValidRN(rn)) {
      getCampaigsByRn(rn, authState.accessToken.accessToken)
        .then((res) => {
          let errorValidation = validationRules(res, userInfo);
          if (errorValidation) {
            setContainsError(true);
          } else {
            setCampaignAssigned(res);
            dispatch(setCampaign(res));
          }
        })
        .catch((error) => {
          //Campaign not found
          setContainsError(true);
        });
    }
  }, [userInfo, campaignAssigned]);

  useEffect(() => {
    if (!survey && campaignAssigned && !containsError) {
      getSurveyById(campaignAssigned.surveyId, authState.accessToken.accessToken).then((s) => {
        setSurvey(s);
      });
    }
  }, [survey, campaignAssigned]);

  useEffect(() => {
    if (campaignAssigned && userInfo && survey && !containsError && !surveyResponseHome) {
      getSurveyResponse(campaignAssigned, userInfo, authState.accessToken.accessToken)
        .then((res) => {
          dispatch(updateGenResponse({ surveyCode: survey.code, surveyResponse: res }));
          setSurveyResponseHome(res);
        })
        .catch((error) => {
          console.log(error);
          setSurveyResponseHome([]);
        });
    }
  }, [campaignAssigned, userInfo, dispatch, surveyResponseHome, survey]);

  if (!rn || containsError || !isValidRN(rn)) {
    return (
      <Redirect
        to={{
          pathname: "/error",
          state: { errorTitle: ERR_TITLE_REQUEST_NUMBER, errorDescription: ERR_DESC_REQUEST_NUMBER, errorUrl: actualURL, errorUser: userInfo ? userInfo.userID : "" },
        }}
      />
    );
  }
  if (!userInfo || !survey || !campaignAssigned) {
    return (
      <div>
        <h5>Loading...</h5>
      </div>
    );
  } else if (sentToReview(campaignAssigned)) {
    //when its close or submitted
    return (
      <Redirect
        to={{
          pathname: "/review",
          state: {
            previous: "/survey",
            survey: survey,
            updatedByName: props.location && props.location.state ? props.location.state.updatedByName : '',
            updatedTs: props.location && props.location.state ? props.location.state.updatedTs : '',
            status:  campaignAssigned.assignments[0].status,
            campaign: campaignAssigned,
            supplierName: campaignAssigned.assignments[0].supplierName,
            surveyType: survey.description,
            dueDate: campaignAssigned.dueDate,
          },
        }}
      />
    );
  } else {
    return <OSSurveyPage survey={survey} setSurvey={setSurvey} />;
  }
};

export default HomeOSPage;
